<template>
  <PortalWidget
    :widget="widgetTitle"
  >
    <!-- Table Container -->
    <div
      v-if="!isLoadingTransactions"
      class="grid_table_holder"
      data-testid="transaction-history"
    >
      <v-table
        :data="transactionHistory"
        :current-page.sync="currentPage"
        :page-size="20"
        :hide-sort-icons="true"
        class="table_beauty"
        @totalPagesChanged="totalPages = $event"
      >
        <thead slot="head">
          <tr>
            <v-th
              default-sort="desc"
              sort-key="dtStamp"
              v-t="'ACCOUNT_BILLING_HISTORY_DATE'"
            />
            <v-th
              sort-key="description"
              v-t="'ACCOUNT_BILLING_HISTORY_DESCRIPTION'"
            />
            <v-th
              sort-key="amount.amount"
              v-t="'ACCOUNT_BILLING_HISTORY_AMOUNT'"
            />
            <v-th
              sort-key="cardType"
              v-t="'ACCOUNT_BILLING_HISTORY_TYPE'"
            />
            <v-th
              sort-key="cC_Last_4"
              v-t="'ACCOUNT_BILLING_HISTORY_NUMBER'"
            />
            <th v-t="'TRANSACTION_HISTORY_RECEIPT'" />
          </tr>
        </thead>
        <tbody
          slot="body"
          slot-scope="{ displayData }"
        >
          <tr v-if="!transactionHistory.length">
            <td colspan="100" v-t="'TRANSACTION_HISTORY_EMPTY'"></td>
          </tr>

          <!-- Rows -->
          <template v-for="(row, index) in displayData">
            <tr
              :key="row.refId"
              :class="{
                'bg-row-odd': index % 2 === 0,
                'bg-row-even': index % 2 !== 0,
              }"
            >
              <!-- Date -->
              <td>
                {{ formatDate(row.dtStamp) }}
              </td>
              <!-- Description -->
              <td>
                {{ row.description }}
              </td>
              <!-- Amount -->
              <td>
                {{ formatCurrency(row.amount.amount) }}
              </td>
              <!-- Type -->
              <td>
                <i
                  class="credit-card-img" 
                  :class="row.cardType" 
                />
              </td>
              <!-- CC -->
              <td>
                xxxx-xxxx-xxxx-{{ row.cC_Last_4 }}
              </td>
              <!-- Download -->
              <td>
                <button
                  class="btn btn-list-function" 
                  :disabled="row.isExportingInvoice"
                  @click="exportCreditCardInvoice(row)"
                >
                  <Loader v-if="row.isExportingInvoice" custom-class="size-sm"/>
                  <i
                    v-else
                    v-tooltip.right.hover="{ text:$t('ACCOUNT_BILLING_HISTORY_INVOICE_TT'), transition: 0 }"
                    class="fa fa-download"
                    aria-hidden="true"
                  />
                </button>
              </td>
            </tr>
          </template>
        </tbody>
      </v-table>
      <div v-if="transactionHistory && transactionHistory.length" class="pagination-min">
        <div class="text-center p-7">
          <smart-pagination
            :current-page.sync="currentPage"
            :total-pages="totalPages"
            :max-page-links="7"
          />
        </div>
      </div>
    </div>
    <div
      v-else
      class="text-center empty-records"
    >
      <Loader />
      <span v-t="'LOADING'" />
    </div>
  </PortalWidget>
</template>

<script>
import moment from 'moment';
import { billingInvoiceService, utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { utcToLocalFormat } from '@/core/filters/utcToLocalFormat';
import currencyFormatter from '@/core/filters/formatCurrency.js';
import messages from '../../locales';
import sharedMessages from '@/core/locales';
import { mapState } from 'vuex';

export default {
  name: 'TransactionHistory',
  components: {
  },
  props: {
  },
  data() {
    return {
      widgetTitle: { title: this.$t('ACCOUNT_BILLING_HISTORY_HEADER'), iconClass: 'typcn typcn-credit-card' },
      transactionHistory: null,
      currentPage: 1,
      totalPages: 0,
      isLoadingTransactions: false
    };
  },
  computed: {
    ...mapState({
      accountId: 'currentAccountId',
    }),
  },
  created() {
    this.loadTransactionHistory();
  },
  methods: {
    async loadTransactionHistory() {
      this.isLoadingTransactions = true;
      try {
        const response = await billingInvoiceService.getCCTransactions(this.accountId);
        this.transactionHistory = response.data.ccTransactions.sort((a, b) => moment(b.dtStamp).valueOf() - moment(a.dtStamp).valueOf());
      } catch (e) {
        utilities.errorHandler(this.$t('TRANSACTION_HISTORY_ERROR'));
      } finally {
        this.isLoadingTransactions = false;
      }
      
    },
    formatDate(date) {
      const format = 'MMMM D, YYYY - HH:mm A';
      if (!date) {
        return '';
      } else {
        return utcToLocalFormat(date, format);
      }
    },
    formatCurrency(value) {
      return currencyFormatter(value, 'en-US', 2);
    },
    async exportCreditCardInvoice(row) {
      const item = this.transactionHistory.find(item => item.refId === row.refId);
      if (item) {
        this.$set(item, 'isExportingInvoice', true);
      }
      try {
        await this.$store.dispatch('exportFiles/exportCCInvoice', { transaction: row });
      } catch (e) {
        utilities.errorHandler(e);
      } finally {
        if (item) {
          item.isExportingInvoice = false;
        }
      }
    },
  },

  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>